var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#4c5969",
    width: 28,
    height: 28,
    x: -30,
    y: -30,
    rx: 1.4,
    ry: 1.4,
    transform: "matrix(0,-1,-1,0,0,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m2 28.6v1c0 0.775 0.6248 1.4 1.4004 1.4h25.2c0.775 0 1.4-0.625 1.4-1.4v-1c0 0.775-0.625 1.4-1.4 1.4h-25.2c-0.7752 0-1.4-0.625-1.4-1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "m3.4004 2c-0.7756 0-1.4004 0.6248-1.4004 1.4004v1c0-0.7756 0.6248-1.4004 1.4004-1.4004h25.2c0.775 0 1.4 0.6248 1.4 1.4004v-1c0-0.7756-0.625-1.4004-1.4-1.4004h-25.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m17.736 17.501 3.229-5.742 1.535 5.742-1.535 5.74zm-1.5737 1.2661 3.2292 5.4069-5.623-1.484-4.0635-3.923zm3.2285-7.9408-3.2285 6.0408h-6.4577l4.063-4.5564zm4.61 4.6738-1.97-7.5-7.352 2.0225-1.088 1.9705-2.209-0.016-5.381 5.524 5.3813 5.5231h0.000263l2.2074-0.01683 1.0899 1.9705 7.3513 2.0222 1.97-7.5-1-1.999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.736 16.501 3.229-5.742 1.535 5.742-1.535 5.74zm-1.5737 1.2661 3.2292 5.4069l-5.623-1.484-4.0635-3.923zm3.2285-7.9408-3.2285 6.0408h-6.4577l4.063-4.5564zm4.61 4.6738-1.97-7.5-7.352 2.0225-1.088 1.9705-2.209-0.016-5.381 5.524l5.3813 5.5231h0.000263l2.2074-0.01683 1.0899 1.9705 7.3513 2.0222 1.97-7.5-1-1.999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.3bec2cb950adf13485951615a4a8fdaa.svg";
export { ForwardRef as ReactComponent };